module.exports = __webpack_public_path__ + "assets/ic_video_normal.svg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/video/ic_video_normal.svg
// module id = 453
// module chunks = 19